const assetURLs = {
    LOGO_WHITE: 'https://d3esz4e2jyp077.cloudfront.net/app/logo/influns-logo-white.png'
}

export default assetURLs